import React from "react";
import { Input } from "@/components/ui/input";
import { Filter } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { t } from "@/i18n";

const inputCls = "bg-[#FFFAF0] border-[#D8CFBB] text-[#1A1610] focus-visible:ring-[#C5A880] h-9";

/** Search mandate filters strip (area + max budget). */
export default function SearchFilters({ area, setArea, maxBudget, setMaxBudget, hasAny, onReset }) {
  const { lang } = useApp();
  return (
    <div
      className="flex items-center gap-3 flex-wrap p-3 rounded-lg border border-[#D8CFBB] bg-[#FFFAF0]"
      data-testid="mk-searches-filters"
    >
      <Filter className="h-4 w-4 text-[#C5A880]" />
      <Input
        data-testid="mk-filter-area"
        placeholder={t("area_placeholder", lang)}
        value={area}
        onChange={(e) => setArea(e.target.value)}
        className={`${inputCls} max-w-[200px]`}
      />
      <Input
        data-testid="mk-filter-max-budget"
        placeholder={t("max_budget_placeholder", lang)}
        type="number"
        value={maxBudget}
        onChange={(e) => setMaxBudget(e.target.value)}
        className={`${inputCls} max-w-[200px]`}
      />
      {hasAny && (
        <button onClick={onReset} data-testid="mk-searches-reset" className="text-xs text-[#C5A880] hover:underline">
          {t("reset_filters", lang)}
        </button>
      )}
    </div>
  );
}
